import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

import { getCookie } from '../../../../utils/utility';
import { updateUserSession } from './sessionManagement';

export const getUserSession = createAsyncThunk(
  'getUserSession',
  async (_, thunkAPI) => {
    const token = await getCookie('token');
    const state: any = thunkAPI.getState();
    const { app } = state.application;
    await axios
      .post(
        `${process.env.REACT_APP_NODE_BACKEND_URL}/api/get-user-session`,
        { app },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then(async (response) => {
        const transformedData = response.data.map((group: any) => ({
          ...group,
          users: group.users.map((user: any) => ({
            ...user,
            sessions: user.sessions.map((session: any) => ({
              ...session,
              login_timestamp: new Date(
                session.login_timestamp * 1000,
              ).toLocaleString(),
              session_validity: new Date(
                session.session_validity * 1000,
              ).toLocaleString(),
              status:
                session.session_validity > session.login_timestamp
                  ? 'Active'
                  : 'Inactive',
            })),
          })),
        }));
        await thunkAPI.dispatch(updateUserSession(transformedData));
      })
      .catch((error: any) => {
        if (error) {
          toast.error(error.response.data.message);
        }
      });
  },
);

export const revokeUserSession = createAsyncThunk(
  'revokeUserSession',
  async (selectedSessionKeys: string[], thunkAPI) => {
    const token = await getCookie('token');
    const state: any = thunkAPI.getState();
    const { app } = state.application;
    await axios
      .post(
        `${process.env.REACT_APP_NODE_BACKEND_URL}/api/revoke-user-session`,
        { app, sessionKeys: selectedSessionKeys },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then(async (response) => {
        const transformedData = response.data.map((group: any) => ({
          ...group,
          users: group.users.map((user: any) => ({
            ...user,
            sessions: user.sessions.map((session: any) => ({
              ...session,
              login_timestamp: new Date(
                session.login_timestamp * 1000,
              ).toLocaleString(),
              session_validity: new Date(
                session.session_validity * 1000,
              ).toLocaleString(),
              status:
                session.session_validity > session.login_timestamp
                  ? 'Active'
                  : 'Inactive',
            })),
          })),
        }));
        await thunkAPI.dispatch(updateUserSession(transformedData));
      })
      .catch((error: any) => {
        if (error) {
          toast.error(error.response.data.message);
        }
      });
  },
);
